declare namespace $ {

	export class $mol_icon_form_select extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=select.view.tree.d.ts.map